import React from 'react';
import { ReactComponent as VentoryWhiteSvg } from '../../../assets/img/Ventory-WhiteNoBack.svg';

export default function VentoryWhiteLogo() {
  return <VentoryWhiteSvg height='32px' />;
}
